import React, { useState, useEffect } from "react";
import Style from '../css/privacyStyle/privacy.module.css';
import { GetUrlVars, ResetUrl } from '../services/data.service';
import {useTranslation, withTranslation} from "react-i18next";

//https://selfenroll.proptech.ai/privacy?site=Facelabs&address=FaceLabs%20Offices
function Privacy() {
    const { t } = useTranslation();
    const [site, setSite] = useState("");
    const [address, setAddress] = useState("");
    const [contact_mail, setContantEmail] = useState("");

    useEffect(() => {
        const params = GetUrlVars();
        ResetUrl('/register_privacy');
        if (params.contact_mail) {
            setContantEmail(params.contact_mail)
        }
        if (params.site) {
            setSite(decodeURIComponent(params.site))
        }
        if (params.address) {
            setAddress(decodeURIComponent(params.address))
        }
        return () => {
            // Clean up the subscription
        };
    }, []);

    return (
        <>
            <h2>{t("privacy_statement_title", { site })}</h2>
            <ul className={Style.Ul}>
                <li className={Style.Li}>
                    <strong>{t("privacy_intro_title")}</strong> <br />
                    {t("privacy_intro_text", { address })}
                </li>
                <li className={Style.Li}>
                    <strong>{t("privacy_voluntary_title")}</strong> <br />
                    {t("privacy_voluntary_text")}
                </li>
                <li className={Style.Li}>
                    <strong>{t("privacy_data_collection_title")}</strong> <br />
                    {t("privacy_data_collection_text")}
                </li>
                <li className={Style.Li}>
                    <strong>{t("privacy_data_usage_title")}</strong> <br />
                    {t("privacy_data_usage_text")}
                </li>
                <li className={Style.Li}>
                    <strong>{t("privacy_data_retention_title")}</strong> <br />
                    {t("privacy_data_retention_text", { contact_mail })}
                </li>
            </ul>
        </>
    );
}

// Wrap component with `withTranslation()` for class components
export default withTranslation()(Privacy);
